import axios from "axios";

export default class CookieConsentSaving {
    constructor() {
        this.apiUrl = "/api/CookieConsentSaving/SaveConsentData";
    }

    saveConsentToDatabase(categoryName, status) {
        axios.post(this.apiUrl, { categoryName, status }).then((response) => {
            if (response.data.statusCode !== 200) {
                console.error(response);
            }
        });
    }
}

if (window.cookieConfig) {
    window.cookieConfig.acceptCallback = function saveAcceptToDb(k) {
        const cookieConsentSaving = new CookieConsentSaving();
        cookieConsentSaving.saveConsentToDatabase(k, "accept");
    };

    window.cookieConfig.declineCallback = function saveDeclineToDb(l) {
        const cookieConsentSaving = new CookieConsentSaving();
        cookieConsentSaving.saveConsentToDatabase(l, "decline");
    };
}
